module.exports = __webpack_public_path__ + "assets/img/hall.b002633e.webp";